import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const generateInventoryLevelReport = {
  name: "generateInventoryLevelReport" as const,
  input: z.object({
    locationIds: z.array(z.string()).optional(),
    productIds: z.array(z.string()).optional(),
    sendToEmail: z.string().email().optional(),
    exportFormat: createEnum(["summary", "detailed"]).optional(),
  }),
  output: z.object({
    success: z.boolean(),
    message: z.string(),
    reportData: z
      .array(
        z.object({
          productName: z.string(),
          sku: z.string(),
          status: z.string(),
          price: z.number().nullable(),
          cost: z.number().nullable(),
          location: z.string(),
          available: z.number(),
          buildable: z.number(),
          committed: z.number(),
          reserved: z.number(),
          onHand: z.number(),
          totalPrice: z.number().nullable(),
          totalCost: z.number().nullable(),
          isTotal: z.boolean(),
        }),
      )
      .optional(),
    emailSent: z.boolean().optional(),
  }),
};
